import { render, staticRenderFns } from "./MJPlayer.vue?vue&type=template&id=78a16b78&scoped=true"
import script from "./MJPlayer.vue?vue&type=script&lang=js"
export * from "./MJPlayer.vue?vue&type=script&lang=js"
import style0 from "./MJPlayer.vue?vue&type=style&index=0&id=78a16b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a16b78",
  null
  
)

export default component.exports